export default __webpack_public_path__ + "static/media/logo.cfbe5ae3.svg";